import { render, staticRenderFns } from "./confectionIncentiveModal.vue?vue&type=template&id=1d63ec48&"
import script from "./confectionIncentiveModal.vue?vue&type=script&lang=js&"
export * from "./confectionIncentiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports